import React, { forwardRef } from 'react'
import AddEditCatalogueItem from './AddEditCatalogueItem'
import DeleteCatalogueItem from './DeleteCatalogueItem'

const ModifyCatalogueItem = forwardRef((props, ref) => {
  return (
    <>
      <AddEditCatalogueItem ref={ref} getData={props.getData} />
      <DeleteCatalogueItem ref={ref} getData={props.getData} />
    </>
  )
})

export default ModifyCatalogueItem
